import { useContext } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import "../assets/css/style.css";
import { ToastSucesso } from "../components/toast";
import DrawerThemeContext from "../context/drawerTheme/DrawerThemeContext";
import UserContext from "../context/user/UserContext";
import { LogoutService } from "../services/auth";

const Layout = () => {

    const drawer = () => {
        (window as any).$("body").toggleClass("drawer-toggled");
    }

    const { user, roles } = useContext(UserContext);

    const { drawerTheme } = useContext(DrawerThemeContext);

    const navigate = useNavigate();

    // funcao para fazer logout
    const logout = async () => {

        await LogoutService();

        localStorage.removeItem('token');

        ToastSucesso('Deslogado com sucesso');
        navigate('/');

    }
    // funcao para fazer logout

    return (
        <>
            <nav className="top-app-bar navbar navbar-expand navbar-dark bg-primary">
                <div className="container-fluid px-4">
                    <button className="btn btn-lg btn-icon order-1 order-lg-0" type="button" onClick={drawer}><i className="material-icons">menu</i></button>
                    <span className="navbar-brand me-auto"><div className="text-uppercase font-monospace">RDI</div></span>
                    <div className="d-flex align-items-center mx-3 me-lg-0">

                        <div className="d-flex">
                            <div className="dropdown">
                                <button className="btn btn-lg btn-icon dropdown-toggle" id="dropdownMenuProfile" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="material-icons">person</i></button>
                                <ul className="dropdown-menu dropdown-menu-end mt-3" aria-labelledby="dropdownMenuProfile">
                                    <li>
                                        <Link className="dropdown-item" to={"/profile"}>
                                            <i className="material-icons leading-icon">person</i>
                                            <div className="me-3">Perfil</div>
                                        </Link>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <button className="dropdown-item" type="button" onClick={logout}>
                                            <i className="material-icons leading-icon">logout</i>
                                            <div className="me-3">Sair</div>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <div id="layoutDrawer">
                <div id="layoutDrawer_nav">
                    <nav className={drawerTheme === 'dark' ? `drawer accordion drawer-dark bg-dark` : `drawer accordion drawer-light bg-white`} id="drawerAccordion">
                        <div className="drawer-menu">
                            <div className="nav">
                                {
                                    roles.includes(1) && // usuários com permissão de administrador

                                    <>

                                        <div className="drawer-menu-heading">Administrador</div>
                                        <Link className="nav-link" to={'/users'}>
                                            <div className="nav-link-icon"><i className="material-icons">groups</i></div>
                                            Usuários
                                        </Link>
                                        <Link className="nav-link" to={'/users/managers'}>
                                            <div className="nav-link-icon"><i className="material-icons">badge</i></div>
                                            Usuários Administrativos
                                        </Link>
                                        <Link className="nav-link" to={'/cost_centers'}>
                                            <div className="nav-link-icon"><i className="material-icons">account_balance</i></div>
                                            Centros de Custo
                                        </Link>
                                        <Link className="nav-link" to={'/types'}>
                                            <div className="nav-link-icon"><i className="material-icons">format_list_bulleted</i></div>
                                            Tipos
                                        </Link>
                                        <Link className="nav-link" to={'/states'}>
                                            <div className="nav-link-icon"><i className="material-icons">map</i></div>
                                            Estados
                                        </Link>
                                        <Link className="nav-link" to={'/cities'}>
                                            <div className="nav-link-icon"><i className="material-icons">location_on</i></div>
                                            Cidades
                                        </Link>
                                        <Link className="nav-link" to={'/financial_emails'}>
                                            <div className="nav-link-icon"><i className="material-icons">forward_to_inbox</i></div>
                                            E-mails do Financeiro
                                        </Link>
                                    </>
                                }
                                {
                                    roles.includes(2) && // usuários com permissão de gerente

                                    <>

                                        <div className="drawer-menu-heading">Administrativo</div>

                                        <Link className="nav-link" to={'/managers/dashboard'}>
                                            <div className="nav-link-icon"><i className="material-icons">dashboard</i></div>
                                            Dashboard
                                        </Link>
                                        <Link className="nav-link" to={'/managers/cost_centers'}>
                                            <div className="nav-link-icon"><i className="material-icons">account_balance</i></div>
                                            Centros de Custo
                                        </Link>
                                        <Link className="nav-link" to={'/managers/employees'}>
                                            <div className="nav-link-icon"><i className="material-icons">group</i></div>
                                            Funcionários
                                        </Link>
                                        <Link className="nav-link" to={'/managers/orders'}>
                                            <div className="nav-link-icon"><i className="material-icons">list</i></div>
                                            Ordens
                                        </Link>

                                    </>
                                }
                                {
                                    roles.includes(3) &&

                                    <>

                                        <div className="drawer-menu-heading">Financeiro</div>

                                        <Link className="nav-link" to={'/financial/dashboard'}>
                                            <div className="nav-link-icon"><i className="material-icons">dashboard</i></div>
                                            Dashboard
                                        </Link>
                                        <Link className="nav-link" to={'/financial/orders'}>
                                            <div className="nav-link-icon"><i className="material-icons">list</i></div>
                                            Ordens
                                        </Link>
                                    </>
                                }
                                {
                                    roles.includes(4) && // usuários com permissão de aprovador

                                    <>

                                        <div className="drawer-menu-heading">Aprovador</div>

                                        <Link className="nav-link" to={'/approvers/dashboard'}>
                                            <div className="nav-link-icon"><i className="material-icons">dashboard</i></div>
                                            Dashboard
                                        </Link>
                                        <Link className="nav-link" to={'/approvers/orders'}>
                                            <div className="nav-link-icon"><i className="material-icons">list</i></div>
                                            Todas as Ordens
                                        </Link>
                                        <Link className="nav-link" to={'/approvers/orders/pending'}>
                                            <div className="nav-link-icon"><i className="material-icons">pending_actions</i></div>
                                            Ordens Pendentes
                                        </Link>

                                    </>
                                }

                            </div>
                        </div>
                        <div className="drawer-footer border-top">
                            <div className="d-flex align-items-center">
                                <i className="material-icons text-muted">account_circle</i>
                                <div className="ms-3">
                                    <div className="caption">Logged in as:</div>
                                    <div className="small fw-500">{user?.name}</div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
                <div id="layoutDrawer_content">
                    <main>
                        <Outlet />
                    </main>
                </div>
            </div>
        </>
    )

}

export default Layout;